
const ALLOWED_TOKEN = process.env.REACT_APP_ALLOWED_TOKEN;

export const headers = {
  Authorization: `Bearer ${ALLOWED_TOKEN}`,
  'Content-Type': 'application/json',
};

